import { clearPending } from "@utils/axios"
import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router'
import mainRoutes from './main'
import enterpriseCustomizationRoutes from './customEnterprise'
import { ENV } from "@config/config"

let createWebHistoryPath = ENV == 'development' || ENV == 'test'?'pc':'';

const router = createRouter({
    history: createWebHistory(createWebHistoryPath),
    routes: mainRoutes.concat(enterpriseCustomizationRoutes)
})

router.beforeEach( (to, from, next) => {
    try {
        clearPending()
    } catch (error) {}
    document.title = String(to.meta?.title || '');
    next()
})

export default router